let cardActionService = (paymentErrorService) => {
  let handleCardActionGateway;

  const setHandleCardAction = actionCreator => handleCardActionGateway = actionCreator;

  const handleCardAction = (clientSecret) => {
    if (handleCardActionGateway) {
      return handleCardActionGateway(clientSecret)
        .then(response => {
          if (!response.paymentIntent || (response.paymentIntent && !response.paymentIntent.id)) {
            throw { message: paymentErrorService.formatError('Sorry, your card could not be authorised.') };
          }

          return true;
        })
        .catch(error => {
          throw [ error.message ];
        });
    }

    return Promise.reject([ 'No valid gateway found' ]);
  };

  return {
    setHandleCardAction,
    handleCardAction
  };
};

cardActionService.$inject = [ 'paymentErrorService' ];

export default cardActionService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/services/card.action.service.js